'use strict';

const { alertMessage } = require('../common/common');
const base = require('../product/base');
const common = require("../common/common");
const { SELECTORS, CLASSES, EVENTS } = require('./variables');
const Coupon = require('./coupon');

class Cart {
    constructor(element) {
        this.element = element;
        this.minicart = $(SELECTORS.minicart);
        this.minicartQty = $(SELECTORS.minicartQty);
        this.minicartLink = $(SELECTORS.minicartLink);
        this.editProductModal = $(SELECTORS.editProductModal);
        this.initEvents();
        this.coupon = new Coupon();
    }
    
    initEvents() {
        $('body').off('click', SELECTORS.removeProduct).on('click', SELECTORS.removeProduct, (e) => {
            e.preventDefault();
            const $this = $(e.currentTarget);
            const url = $this.data('action');
            const productID = $this.data('pid');
            const uuid = $this.data('uuid');
    
            this.removeProduct(productID, uuid, url, $this);
        });

        this.element.on('click', SELECTORS.bonusProductButton, () => {
            $.spinner().start();
            $(this).addClass(CLASSES.launchedModal);
            $.ajax({
                url: $(this).data('url'),
                method: 'GET',
                dataType: 'json',
                success: (data) => {
                    base.methods.editBonusProducts(data);
                    $.spinner().stop();
                },
                error: () => {
                    $.spinner().stop();
                }
            });
        });

        $('body').on('click', SELECTORS.edit, (evt) => {
            evt.preventDefault();
    
            const editProductUrl = $(evt.currentTarget).attr('href');
            this.fillModalElement(editProductUrl);
        });

        $('body').on(EVENTS.updateAddToCart, (e, response) => {
            const dialog = $(response.$productContainer).closest('.quick-view-dialog');
            $(SELECTORS.updateCartProductGlobal, dialog).attr(
                'disabled',
                !$(SELECTORS.globalAvailability, dialog).data('ready-to-order')
                || !$(SELECTORS.globalAvailability, dialog).data('available')
            );
            if ($(SELECTORS.globalAvailability, dialog).length < 1) {
                $(SELECTORS.updateCartProductGlobal, dialog).attr(
                    'disabled', !response.product.readyToOrder
                );
                $(SELECTORS.updateCartProductGlobal).attr('data-pid', response.product.id);
            }
        });
    
        $('body').on(EVENTS.updateAvailability, (e, response) => {
            // bundle individual products
            $(SELECTORS.productAvailability, response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
    
            const dialog = $(response.$productContainer).closest(SELECTORS.quickViewDialog);
    
            if ($(SELECTORS.productAvailability, dialog).length) {
                const allAvailable = $(SELECTORS.productAvailability, dialog).toArray().every(function (item) { return $(item).data('available'); });
                const allReady = $(SELECTORS.productAvailability, dialog).toArray().every(function (item) { return $(item).data('ready-to-order'); });
                $(SELECTORS.globalAvailability, dialog).data('ready-to-order', allReady).data('available', allAvailable);
                $(SELECTORS.availabilityMsg, dialog).empty().html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                $(SELECTORS.globalAvailability, dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
                if ($(SELECTORS.globalAvailability, dialog).length < 1) {
                    if ($(SELECTORS.updateCartProductGlobal).length == 1) {
                        $(SELECTORS.updateCartProductGlobal).attr('disabled', response.product.readyToOrder);
                        $(SELECTORS.updateCartProductGlobal).attr('data-pid', response.product.id);
                    }
                }
            }
        });
    
        $('body').on(EVENTS.afterAttributeSelect, (e, response) => {
            if ($('.modal.show .product-quickview .bundle-items').length) {
                $('.modal.show').find(response.container).data('pid', response.data.product.id);
                $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
            } else {
                $('.modal.show .product-quickview').data('pid', response.data.product.id);
            }
        });

        $('body').on('input', SELECTORS.changeQty, (evt) => {
            const $this = $(evt.currentTarget);
            const selectedQuantity = $this.val();
            $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
        });
    
        $('body').on('change', SELECTORS.optionsSelect, (evt) => {
            const $this = $(evt.currentTarget);
            const selectedOptionValueId = $this.children('option:selected').data('value-id');
            $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
        });

        $('body').on('quantiy:negative', (e, data) => {
            let $target = $(data.target);
            let productID = $target .data('pid');
            let uuid = $target.data('uuid');
            let removeAction = $target.data('remove-action');

            this.removeProduct(productID, uuid, removeAction);
        });

        $('body').on('input', SELECTORS.quantity, (e) => {
            let $this = $(e.currentTarget);
            let preSelectQty = $this.data('pre-select-qty');
            let quantity = $this.val();
            let productID = $this.data('pid');
            let url = $this.data('action');
            let uuid = $this.data('uuid');
            let urlParams = {
                pid: productID,
                quantity: quantity,
                uuid: uuid
            };
            url = this.appendToUrl(url, urlParams);
            $('body').trigger(EVENTS.cartBeforeUpdate);
            $.spinner().start();
    
            $.ajax({
                url: url,
                type: 'get',
                context: this,
                dataType: 'json',
                success: (data) => {
                    const $formCoupon = $('.cc-promo-code-form');
                    const discounts = data.totals.discounts;

                    if (discounts && !discounts.length > 0 && document.querySelector('.cc-promo-code-form--applied')) {
                        $('.coupon-uuid-' + uuid).remove();
                        $(SELECTORS.promoForm).removeClass(CLASSES.couponApplied);
                        $(SELECTORS.couponCodeInput).val('');
                        $(SELECTORS.proCouponBtn).removeClass('cc-active remove-coupon');

                        $('body').trigger('promotion:error', data); 
                        alertMessage($formCoupon.attr('data-message-coupon-conditions-no-longer-met'), 'cc-alert--danger');
                    }

                    $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    this.updateCartTotals(data);
                    this.updateApproachingDiscounts(data.approachingDiscounts);
                    this.updateAvailability(data, uuid);
                    this.validateBasket(data);
                    $this.data('pre-select-qty', quantity);
    
                    $('body').trigger(EVENTS.cartUpdate, data);
    
                    if ($this.parents('.product-info').hasClass('bonus-product-line-item') && $(SELECTORS.element).length) {
                        location.reload();
                        return;
                    }

                    $.spinner().stop();
                },
                error: (err) => {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
                        $this.val(parseInt(preSelectQty, 10));
                        $.spinner().stop();
                    }
                }
            });
        });
    
        $('body').on('click', SELECTORS.updateCartProductGlobal, (e) => {
            e.preventDefault();
            const $this = $(e.currentTarget);
            const updateProductUrl = $this.closest('.cart-and-ipay').find('.update-cart-url').val();
            const selectedQuantity = $this.closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
            const selectedOptionValueId = $this.closest('.detail-panel').find('.options-select.selected').data('value-id') ? 
                $this.closest('.detail-panel').find('.options-select.selected').data('value-id')  :  
                $this.closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
            const uuid = $this.closest('.cart-and-ipay').find('.update-cart-url').data('uuid');
    
            var form = {
                uuid: uuid,
                pid: base.getPidValue($this),
                quantity: selectedQuantity,
                selectedOptionValueId: selectedOptionValueId
            };
    
            $('body').trigger(EVENTS.cartBeforeUpdate);

            $.spinner().start();
    
            if (updateProductUrl) {
                $.ajax({
                    url: updateProductUrl,
                    type: 'post',
                    context: this,
                    data: form,
                    dataType: 'json',
                    success: (data) => {
                        this.editProductModal.modal('hide');
                        $(SELECTORS.couponsAndPromo).empty().append(data.cartModel.totals.discountsHtml);
                        this.updateCartTotals(data.cartModel);
                        this.updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                        this.updateAvailability(data.cartModel, uuid);
                        this.updateProductDetails(data, uuid);
    
                        if (data.uuidToBeDeleted) {
                            $('.uuid-' + data.uuidToBeDeleted).remove();
                        }
                        this.validateBasket(data.cartModel);
                        $('body').trigger('cart:update', data);
                        $('body').trigger(EVENTS.afterEditItem, uuid);
                        $.spinner().stop();
                    },
                    error: (err) => {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
                        }
                        $.spinner().stop();
                    }
                });
            }
        });

        $('body').on('click', SELECTORS.proSubscription, (e) => {
            $.spinner().start();
            const url = $(e.currentTarget).attr('data-action');
            $.ajax({
                url: url,
                method: 'POST',
                data: '',
                success: () => {
                    window.location.reload();
                },
                error: (err) => {
                    console.error(err);
                    $.spinner().stop();
                }
            });
        });

        $('body').off('click', SELECTORS.resendEmail).on('click', SELECTORS.resendEmail, (e) => {
            $.spinner().start();
            const url = $(e.currentTarget).attr('data-action');
            $.ajax({
                url: url,
                method: 'GET',
                data: '',
                success: (data) => {
                    if (data.success) {
                        alertMessage(data.message, 'cc-alert--success');
                    } else {
                        alertMessage(data.errorMsg, 'cc-alert--danger');
                    }
                    $.spinner().stop();
                },
                error: (err) => {
                    console.error(err);
                    if (err.errorMsg) {
                        alertMessage(err.errorMsg, 'cc-alert--danger');
                    }
                    $.spinner().stop();
                }
            });
        });

        $(SELECTORS.promoForm).on('submit', (e) => {
            e.preventDefault();
            this.couponFormHandler();
        });

        $('body').on('click', SELECTORS.proCouponConfirm, (ev) => {
            ev.preventDefault();
            $.spinner().start();
            const code = ev.currentTarget.getAttribute('data-code');
            document.querySelector('#couponCode').value = code;

            const promotionChange = new Sst();
            promotionChange.jsonPayload.eventType = 'frontendOnClick';
            promotionChange.jsonPayload.elementType = 'trcElements',
            promotionChange.jsonPayload.trcElements = [
                {
                    onClickName: 'promotionChange::'+ev.currentTarget.getAttribute('data-promotionChange'),
                    url: window.location.href,
                }
            ];
            sstWorker.postMessage(promotionChange);

            this.couponFormHandler();
        });

        $('body').on('click', SELECTORS.moveToWishlist, (e) => {
            e.preventDefault();
            const $this = $(e.currentTarget);
            const url = $this.attr('href');
            const pid = $this.data('pid');
            let optionId = $this.closest('.product-info').find('.line-item-option').data('option-id');
            let optionVal = $this.closest('.product-info').find('.line-item-option').data('option-selected-value');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }
    
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: (data) => {
                    $.spinner().stop();
                    alertMessage(data.msg, 'cc-alert--success');
                    const $targetElement = $('a[data-pid="' + data.pid + '"]').closest('.product-info').find('.remove-product');
                    let actionUrl = $targetElement.data('action');
                    const productID = $targetElement.data('pid');
                    const uuid = $targetElement.data('uuid');
                    this.removeProduct(productID, uuid, actionUrl);
                },
                error: (err) => {
                    $.spinner().stop();
                    alertMessage(err.msg, 'cc-alert--danger');
                }
            });
        });

        $('body').on('click', SELECTORS.removeCoupon, (e) => {
            e.preventDefault();
            
            this.setCouponSummaryState(false);
            const $this = $(e.currentTarget);
            let url = $this.attr('data-action');
            const couponCode = $this.attr('data-code');
            const uuid = $this.attr('data-uuid');
            const urlParams = {
                code: couponCode,
                uuid: uuid
            };
    
            url = this.appendToUrl(url, urlParams);
    
            $('body > .modal-backdrop').remove();
    
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: (data) => {
                    $('.coupon-uuid-' + uuid).remove();
                    $(SELECTORS.promoForm).removeClass(CLASSES.couponApplied);
                    $(SELECTORS.couponCodeInput).val('');
                    $(SELECTORS.proCouponBtn).removeClass('cc-active remove-coupon');
                    let giftcardInput = $(SELECTORS.giftcardInput).val();
                    $('body').trigger('giftcard:totalChange', giftcardInput);
                    this.updateCartTotals(data);
                    this.updateApproachingDiscounts(data.approachingDiscounts);
                    this.validateBasket(data);

                    if (window.spsDataLayer.internal.promotionState.promotionActive) {
                        $(SELECTORS.vorteilsprogrammSwitchId).prop('checked', false);
                        $(SELECTORS.vorteilsprogramm).removeClass('cc-vorteilsprogramm--activated');
                    }

                    if (window.spsDataLayer.internal.promotionState.isAffiliateProgrammActive) {
                        $(SELECTORS.vorteilsprogrammSwitchId).prop('checked', true);
                        $(SELECTORS.vorteilsprogramm).addClass('cc-vorteilsprogramm--activated');
                    }

                    $(SELECTORS.couponDescription).addClass('d-none');

                    $(SELECTORS.removeCoupon).removeAttr('data-code');
                    $(SELECTORS.removeCoupon).removeAttr('data-uuid');

                    $.spinner().stop();
                    $('body').trigger('promotion:success', data);
                },
                error: (err) => {
                    $('body').trigger('promotion:error', err);
                    if (err.responseJSON && err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
                        $.spinner().stop();
                    }
                }
            });
        });

        $('body').on('coupon:apply', (state) => {
            this.couponFormHandler();
        });

        $('body').on(EVENTS.afterAddToCart, (e, response) => {
            if ($('.cart-page.js-cart').length > 0) {
                window.location.reload();
            }
        });

        $('#couponCodeModal').on('hide.bs.modal', (ev) => {
            $('#couponCodeModal .cc-popup__text').addClass('d-none');
        });
 
        if ($(SELECTORS.cartFinalSubtotal).length > 0 && $(SELECTORS.cartFixedButton).length > 0) {
            common.getWindowSizes();
            const stickySectionHeight = $(SELECTORS.cartFixedButton).outerHeight();

            $(window).on('scroll', () => {
                if (!window.isDesktop) {
                    let subtotalTop = $(SELECTORS.cartFinalSubtotal).offset().top;
                    let scrollTop = $(window).scrollTop();
                    let windowHeight = $(window).innerHeight();

                    if ((scrollTop + windowHeight - stickySectionHeight + 17) >= (subtotalTop)) {
                        $(SELECTORS.cartFixedButton).addClass(CLASSES.hide);
                    } else {
                        $(SELECTORS.cartFixedButton).removeClass(CLASSES.hide);
                    }
                }
            });
        }
    }

    /**
     * Handles the submission of the coupon form
     * @returns {void}
     */
    couponFormHandler() {
        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        var $form = $(SELECTORS.promoForm);
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('cc-invalid');
            $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            alertMessage($form.attr('data-message-coupon-missing'), 'cc-alert--danger');
            $.spinner().stop();
            return false;
        }
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        const formattedVal = $form.find('.coupon-code-field').val().replace(/\s/g, '');
        $form.find('.coupon-code-field').val(formattedVal);

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: (data) => {
                if (data.error) {
                    $(SELECTORS.promoForm).removeClass(CLASSES.couponApplied);
                    $(SELECTORS.proCouponBtn).removeClass('cc-active remove-coupon');
                    $(SELECTORS.couponCodeInput).val('');
                    if (data.basket) {
                        this.updateCartTotals(data.basket);
                        this.updateApproachingDiscounts(data.basket.approachingDiscounts);
                        this.validateBasket(data.basket);
                    }
                    $('body').trigger('promotion:error', data);
                    alertMessage(data.errorMessage, 'cc-alert--danger');
                    $(SELECTORS.couponDescription).addClass('d-none');
                    $.spinner().stop();
                } else {

                    const discounts = data.totals.discounts;
                    let couponCode = '';
                    let giftcardInput = $(SELECTORS.giftcardInput).val();
                    $('body').trigger('giftcard:totalChange', giftcardInput);
                    this.updateCartTotals(data);
                    this.updateApproachingDiscounts(data.approachingDiscounts);
                    this.validateBasket(data);

                    if (this.checkCouponIsApplied(discounts)) {
                        $('body').trigger('promotion:success', data);
                        alertMessage($form.attr('data-message-coupon-success'), 'cc-alert--success');
                        this.setCouponDescription(discounts);
                    }

                    if (discounts && discounts.length > 0) {
                        discounts.forEach((element) => {
                            if (element.type === 'coupon' && element.applied) {
                                $(SELECTORS.removeCoupon).attr('data-code', element.couponCode);
                                $(SELECTORS.removeCoupon).attr('data-uuid', element.UUID);
                                couponCode = element.couponCode;                                
                            } 
                        });
                    }

                    if (couponCode) {
                        $(SELECTORS.proCouponBtn).removeClass('cc-active remove-coupon');

                        if (couponCode === $(SELECTORS.vorteilsprogrammSwitchId).data('code')) {
                            $(SELECTORS.vorteilsprogrammSwitchId).prop('checked', true);
                            $(SELECTORS.vorteilsprogramm).addClass('cc-vorteilsprogramm--activated');
                            $(SELECTORS.couponCodeInput).val('');
                            $(SELECTORS.promoForm).removeClass(CLASSES.couponApplied);
                        } else {
                            $(SELECTORS.promoForm).addClass(CLASSES.couponApplied);
                            $(SELECTORS.proCouponBtn + '[data-code="' + couponCode + '"]').addClass('cc-active remove-coupon');
                            $(SELECTORS.vorteilsprogrammSwitchId).prop('checked', false);
                            $(SELECTORS.vorteilsprogramm).removeClass('cc-vorteilsprogramm--activated');
                        }
                        this.setCouponSummaryState(true);
                    } 

                    if (!this.checkCouponIsApplied(discounts)) {
                        let modalCouponDescription = "";
                        let couponsArray = [];
                        if (Array.isArray(discounts) && discounts.length > 0) {
                            discounts.forEach((discount) => {
                                if (discount.type === 'coupon' && !discount.applied) {
                                    modalCouponDescription += `
                                        <div class="cc-modal-coupon-content">
                                            <p class="cc-modal-coupon-content__couponCode">${discount.couponCode}:</p>
                                            <p class="cc-modal-coupon-content__description">${discount.condition ? discount.condition : discount.description ? discount.description : ''}</p>
                                        </div>
                                    `;
                                    couponsArray.push(discount.couponCode);
                                }
                            });
                        }
                        if (couponsArray.length === 0 && data.couponPromoDetails && data.couponPromoCode) {
                            modalCouponDescription += `
                                <div class="cc-modal-coupon-content">
                                    <p class="cc-modal-coupon-content__couponCode">${data.couponPromoCode}:</p>
                                    <p class="cc-modal-coupon-content__description">${data.couponPromoDetails}</p>
                                </div>
                            `;
                            couponsArray.push(data.couponPromoCode);
                        }

                        const encodedModalHtml = encodeURIComponent(modalCouponDescription);
                        const couponsString = couponsArray.join(' ');

                        let errorMessage = `
                            Der Rabatt konnte nicht auf die Artikel im Warenkorb angewendet werden. Bitte überprüfe die 
                            <span class="cc-modal-trigger-alertmessage js-close-alert"
                                data-toggle="modal"
                                data-target="#coupon-description-modal"
                                data-coupon-description="${encodedModalHtml}"
                                data-coupon-code="${couponsString}">
                                Einlösebedingungen</span>
                            des Coupons.
                        `;

                        $('body').trigger('promotion:error', data);
                        alertMessage(errorMessage, 'cc-alert--danger');
                    }

                    $.spinner().stop();
                }
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                $(SELECTORS.couponCodeInput).val('');
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                    $.spinner().stop();
                } else {
                    alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
                    $.spinner().stop();
                }
            }
        });
    }

    affiliateActive(data) {
        const affiliateIsActiveOnOrder =
            (data?.totals?.discounts || []).some(promotion =>
                promotion?.isAffiliatePromotion === true ||
                promotion?.relationship?.[0]?.isAffiliatePromotion === true
            );

        const affiliateIsActiveOnProduct =
            [
                ...(data?.groupedItems?.productsGroup || []),
                ...(data?.groupedItems?.experiencesGroup || [])
            ].some(group =>
                Array.isArray(group) &&
                group.some(item =>
                    Array.isArray(item?.appliedPromotions) &&
                    item.appliedPromotions.some(promotion =>
                        promotion?.isAffiliatePromotion === true ||
                        promotion?.relationship?.[0]?.isAffiliatePromotion === true
                    )
                )
            );

        if (affiliateIsActiveOnOrder || affiliateIsActiveOnProduct) {
            window.spsDataLayer.internal.promotionState.isAffiliateProgrammActive = true;
            window.spsDataLayer.internal.promotionState.promotionActive = false;
            return true;
        } else {
            window.spsDataLayer.internal.promotionState.isAffiliateProgrammActive = false;
            return false;
        }
    }

    /**
    * Checks if the order has any active Affiliate promotion activated. -> will be changed with ticket NOA-3935
    * @param {object} discounts - The array of discounts to check
    * Sets the result on the global window object.
    */
    updatePromotionState(data) {

        if(this.affiliateActive(data)) {
            return;
        }

        const discounts = data.totals.discounts;
        const activePromotionsProduct = [];
        const activePromotionsExperience = [];

        const collectPromotions = (groups, targetArray) => {
            if (!Array.isArray(groups)) return;

            groups.forEach(group => {
                if (!Array.isArray(group)) return;
                group.forEach(item => {
                    const appliedPromotions = item.appliedPromotions;
                    if (Array.isArray(appliedPromotions) && appliedPromotions.length > 0) {
                        appliedPromotions.forEach(promo => { targetArray.push({ promotion: promo });});
                    }
                });
            });
        };

        collectPromotions(data?.groupedItems?.productsGroup, activePromotionsProduct);
        collectPromotions(data?.groupedItems?.experiencesGroup, activePromotionsExperience);

        if (discounts.length > 0 || activePromotionsProduct.length > 0 || activePromotionsExperience.length > 0) {    
            window.spsDataLayer.internal.promotionState.promotionActive = true;
        } else {
            window.spsDataLayer.internal.promotionState.promotionActive = false;   
        }
    }
    
    /**
     * Updates the coupon summary UI based on the current coupon state.
     *
     * @param {boolean} applied - Indicates whether a coupon is currently applied.
     */
    setCouponSummaryState(applied) {
        if (applied) {
            $('.cc-card__summary__title--applied').removeClass('d-none');
            $('.cc-card__summary__title--not-applied').addClass('d-none');
        } else {
            $('.cc-card__summary__title--applied').addClass('d-none');
            $('.cc-card__summary__title--not-applied').removeClass('d-none');
            $('.coupons-content .js-pro-coupon.cc-active').removeClass('cc-active');
        }
    }

    /**
     * Removes a product from the cart.
     *
     * @param {string} productID - The ID of the product to be removed.
     * @param {string} uuid - The UUID of the product to be removed.
     * @param {string} url - The URL to send the request to.
     * @returns {void}
     */
    removeProduct(productID, uuid, url, target = null) {
        var urlParams = {
            pid: productID,
            uuid: uuid,
            action: 'deleteProduct'
        };

        url = this.appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();

        $('body').trigger(EVENTS.cartBeforeUpdate);

        const $self = this;

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: (data) => {
                if (data.basket.items.length === 0) {
                    if ($(SELECTORS.page).data('action') === 'Cart-Show') {
                        window.location.reload();
                        return;
                    }
                    this.element.addClass(CLASSES.emptyCart);
                    this.minicart.addClass(CLASSES.emptyCart);
                    this.minicartQty.empty().append(data.basket.numItems);
                    this.minicartQty.css('display', () => data.basket.numItems === 0 ? 'none' : 'inline-flex');
                    this.minicartLink.attr({
                        'aria-label': data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems
                    });
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            this.removeProductUpdateItemGroup($('.uuid-' + data.toBeDeletedUUIDs[i]));
                        }
                    }
                    this.removeProductUpdateItemGroup($('.uuid-' + uuid));
                    if (!data.basket.hasBonusProduct) {
                        $(SELECTORS.bonusProduct).remove();
                    }
                    $(SELECTORS.couponsAndPromo).empty().append(data.basket.totals.discountsHtml);
                    this.updateCartTotals(data.basket);
                    this.updateApproachingDiscounts(data.basket.approachingDiscounts);
                    $('body').trigger(EVENTS.setShippingMethodSelection, data.basket);
                    this.validateBasket(data.basket);
                }

                if ($(SELECTORS.page).data('action') !== 'Cart-Show') {
                    $('body').trigger(EVENTS.minicartRefresh);
                } else {
                    if (target && target.hasClass(CLASSES.removeSub)) {
                        window.location.reload();
                        return;
                    }
                }

                $('body').trigger(EVENTS.cartUpdate, data);

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
                    $.spinner().stop();
                }
            }
        });
    }

    /**
     * Removes a product from the cart and updates their item groups.
     * @param {product} product - $product to be removed.
     * @returns {void}
     */

    removeProductUpdateItemGroup(product) {
        if (product.parent().find(".product-info").length > 1) {
            product.remove();
        } else {
            product.parent().remove();
            var productGroupHeadlines = $('.cc-cart__group-headline');
            if (productGroupHeadlines.length === 1) {
                productGroupHeadlines.remove();
            } else {
                for (var i = 0; i < productGroupHeadlines.length; i++) {
                    $(productGroupHeadlines[i]).find(".cc-cart__group-count")[0].innerHTML = productGroupHeadlines.length;
                    $(productGroupHeadlines[i]).find(".cc-cart__group-count-current")[0].innerHTML = i + 1;
                }
            }
        }
    }



    /**
     * Replaces the content in the modal window for product variation to be edited.
     * @param {string} editProductUrl - url to be used to retrieve a new product model
     */
    fillModalElement(editProductUrl) {
        $.ajax({
            url: editProductUrl,
            method: 'GET',
            dataType: 'json',
            success: (data) => {
                const parsedHtml = this.parseHtml(data.renderedTemplate);
                this.editProductModal.find('.js-modal-body').empty().html(parsedHtml.body);
                const targetModal = $(SELECTORS.edit).data('target');
                $(targetModal).modal('show');
                $('body').trigger(EVENTS.editModalReady);

                const $sliders = this.editProductModal.find('.js-slider');
                if ($sliders.length > 0) {
                    $sliders.each((index, slider) => {
                        $(slider).not('.slick-initialized').slick();
                    });
                }
            },
            error: (err) => {
                alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
            }
        });
    }

    /**
     * Parses the html for a modal window
     * @param {string} html - representing the body and footer of the modal window
     *
     * @return {Object} - Object with properties body and footer.
     */
    parseHtml(html) {
        var $html = $('<div>').append($.parseHTML(html));

        var body = $html.find('.product-quickview');
        var footer = $html.find('.modal-footer').children();

        return { body: body, footer: footer };
    }

    /**
     * Updates details of a product line item
     * @param {Object} data - AJAX response from the server
     * @param {string} uuid - The uuid of the product line item to update
     */
    updateProductDetails(data, uuid) {
        $('.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
    }

    /**
     * Updates the availability of a product line item
     * @param {Object} data - AJAX response from the server
     * @param {string} uuid - The uuid of the product line item to update
     */
    updateAvailability(data, uuid) {
        var lineItem;
        var messages = '';

        for (var i = 0; i < data.items.length; i++) {
            if (data.items[i].UUID === uuid) {
                lineItem = data.items[i];
                break;
            }
        }

        if (lineItem != null) {
            $('.availability-' + lineItem.UUID).empty();

            if (lineItem.availability) {
                if (lineItem.availability.messages) {
                    lineItem.availability.messages.forEach(function (message) {
                        messages += '<p class="line-item-attributes">' + message + '</p>';
                    });
                }

                if (lineItem.availability.inStockDate) {
                    messages += '<p class="line-item-attributes line-item-instock-date">'
                        + lineItem.availability.inStockDate
                        + '</p>';
                }
            }

            $('.availability-' + lineItem.UUID).html(messages);
        }
    }

    /**
     * re-renders the approaching discount messages
     * @param {Object} approachingDiscounts - updated approaching discounts for the cart
     */
    updateApproachingDiscounts(approachingDiscounts) {
        var html = '';
        $(SELECTORS.approachingDiscounts).empty();
        if (approachingDiscounts.length > 0) {
            approachingDiscounts.forEach(function (item) {
                html += '<div class="single-approaching-discount text-center">'
                    + item.discountMsg + '</div>';
            });
        }
        $(SELECTORS.approachingDiscounts).append(html);
    }

    /**
     * Re-renders the order totals and the number of items in the cart
     * @param {Object} data - AJAX response from the server
     */
    updateCartTotals(data) {
        $(SELECTORS.shippingCost).empty().append(data.totals.totalShippingCost);
        $(SELECTORS.checkoutBtn).removeClass(CLASSES.hide);
        $(SELECTORS.showBtnPPExpress).removeClass(CLASSES.hide);
        $(SELECTORS.showBtnPPExpressMiniCart).removeClass(CLASSES.hide);

        $(SELECTORS.taxTotal).empty().append(data.totals.totalTax);
        $(SELECTORS.grandTotalSum).empty().append(data.totals.grandTotal);
        $(SELECTORS.grandTotal).empty().append(data.totals.grandTotal);
        $(SELECTORS.subTotal).empty().append(data.totals.subTotal);

        $(SELECTORS.couponSFCCTotal).empty().append(data.totals.couponSFCCTotal);
        this.minicartQty.empty().append(data.numItems);
        this.minicartQty.css('display', () => data.numItems === 0 ? 'none' : 'inline-flex');
        this.minicartLink.attr({
            'aria-label': data.resources.minicartCountOfItems,
            title: data.resources.minicartCountOfItems
        });

        // if is cart digital only
        if (data.groupedItems.experiencesGroup.length >= 1 && data.groupedItems.productsGroup.length === 0) {
            $(SELECTORS.isCartDigitalOnly).removeClass(CLASSES.hidden);
            $(SELECTORS.isNotCartDigitalOnly).addClass(CLASSES.hidden);
        } else {
            $(SELECTORS.isCartDigitalOnly).addClass(CLASSES.hidden);
            $(SELECTORS.isNotCartDigitalOnly).removeClass(CLASSES.hidden);
        }

        // Summary
        if (data.totals.couponSFCCTotal && data.totals.couponSFCCTotal.value > 0) {
            $(SELECTORS.couponSFCCLabel).removeClass(CLASSES.hide);
            $(SELECTORS.couponSFCCTotal).empty().append('-' + data.totals.couponSFCCTotal.formatted);
        } else {
            $(SELECTORS.couponSFCCLabel).addClass(CLASSES.hide);
        }

        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $(SELECTORS.orderDiscountLabel).removeClass(CLASSES.hide);
            $(SELECTORS.orderDiscountTotal).empty().append('-' + data.totals.orderLevelDiscountTotal.formatted);
        } else {
            $(SELECTORS.orderDiscountLabel).addClass(CLASSES.hide);
        }

        if (data.totals.shippingLevelDiscountTotal.value > 0 && !data.totals.freeShippingTotal) {
            $(SELECTORS.shippingDiscountLabel).removeClass(CLASSES.hide);
            $(SELECTORS.shippingDiscountTotal).empty().append('-' + data.totals.shippingLevelDiscountTotal.formatted);
        } else {
            $(SELECTORS.shippingDiscountLabel).addClass(CLASSES.hide);
        }

        data.items.forEach(function (item) {
            $('.uuid-' + item.UUID).find('.js-product-price').replaceWith(item.priceTotal.renderedPrice);
        });

        const minimumOrderValue = $('.js-shipping-discount-component').attr("minimum-order-value");
        const missing = data.minimumOrderValue.valueMissingToReachThreshold;
        const percentageToThreshold = ((minimumOrderValue - missing) / minimumOrderValue) * 100;
        const missingAmount = data.minimumOrderValue.valueMissingToReachThreshold.toFixed(2);
        const onlyExperiencesInCart = this.checkIfOnlyExperiencesInCart(data.groupedItems);

        if (!data.minimumOrderValue.isUnderThreshold || onlyExperiencesInCart) {
            $('.js-shipping-discount-component').attr("minimum-order-value-reached","true");
            $('.js-shipping-discount-component').addClass('d-none');
            $('.js-shipping-discount-component').attr("aria-hidden", "true");
        } else {
            $('.js-shipping-discount-missing-amount').html(missingAmount);
            $('.js-shipping-discount-progress').css('width', percentageToThreshold + '%');
            $('.js-shipping-discount-component').attr("minimum-order-value-reached","false");
            $('.js-shipping-discount-component').removeClass('d-none');
            $('.js-shipping-discount-component').attr("aria-hidden", "false");
        }
        
        this.updatePromotionState(data);
    }

    /**
     * appends params to a url
     * @param {string} url - Original url
     * @param {Object} params - Parameters to append
     * @returns {string} result url with appended parameters
     */
    appendToUrl(url, params) {
        var newUrl = url;
        newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
            return key + '=' + encodeURIComponent(params[key]);
        }).join('&');

        return newUrl;
    }

    /**
     * Checks whether the basket is valid. if invalid displays error message and disables
     * checkout button
     * @param {Object} data - AJAX response from the server
     */
    validateBasket(data) {
        if (data.valid.error) {
            if (data.valid.message || data.valid.messages) {
                location.reload();
            } else {
                $(SELECTORS.minicartExclusion).empty().append('<div class="row"> '
                    + '<div class="col-12 text-center"> '
                    + '<span>' + data.resources.emptyCartMsg + '</span> '
                    + '</div> '
                    + '</div>');
                this.minicart.addClass(CLASSES.minicartEmpty);
                this.minicartQty.empty().append(data.numItems);
                this.minicartQty.css('display', () => data.numItems === 0 ? 'none' : 'inline-flex');
                this.minicartLink.attr({
                    'aria-label': data.resources.minicartCountOfItems,
                    title: data.resources.minicartCountOfItems
                });
            }
        } else {
            $(SELECTORS.cartError).addClass("cc-hidden");
        }
    }
    
    /**
     * Checks whether the cart contains only experience items and no regular products.
     *
     * This function verifies that:
     * - `experiencesGroup` is a non-empty array (at least one experience item is in the cart)
     * - `productsGroup` is either missing or empty (no standard products are in the cart)
     *   Note: `productsGroup` is structured as an array of arrays, so we check both levels.
     *
     * @param {Object} groupedItems - The groupedItems object from the cart data
     * @returns {boolean} - Returns true if only experiences are in the cart, false otherwise
     */
    checkIfOnlyExperiencesInCart(groupedItems) {
        if (!groupedItems) return false;

        const hasExperiences =
        Array.isArray(groupedItems.experiencesGroup) &&
        groupedItems.experiencesGroup.length > 0;

        const hasProducts =
        Array.isArray(groupedItems.productsGroup) &&
        groupedItems.productsGroup.length > 0 &&
        Array.isArray(groupedItems.productsGroup[0]) &&
        groupedItems.productsGroup[0].length > 0;

        return hasExperiences && !hasProducts;
    }

    /**
     * Checks a set of discounts/coupons to see if at least one is not applied
     * 
     * @param {Array} discounts - discounts after redeeming the coupon
     * @returns {Boolean} - Returns false if discount has not applied and true if applied 
     */
    checkCouponIsApplied(discounts) {
        const hasApplied = discounts.some(discount => discount.applied === true);

        if (hasApplied) return true;

        return false;
    }

    setCouponDescription(discounts) {
        const el = document.querySelector('.js-coupon-condition [data-coupon-code]');
        el.dataset.couponCode = discounts[0].couponCode;
        el.dataset.couponDescription = discounts[0].condition ? discounts[0].condition : discounts[0].description ? discounts[0].description : '';
        $(SELECTORS.couponDescription).removeClass('d-none');
    }
}

let cartInstance;

module.exports = () => {
    $(SELECTORS.element).each((index, element) => {
        cartInstance = new Cart($(element));
    });

    base.selectAttribute();
    base.selectAttributeOptions();
    base.selectDropdownOptions();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
};